export var getAuthRequest = function getAuthRequest() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    cookie = _ref.cookie,
    token = _ref.token;
  if (token) {
    return {
      headers: {
        authorization: "Bearer ".concat(token)
      }
    };
  }
  return {
    credentials: cookie || 'include'
  };
};